import WindowModal from './WindowModal';
import ContentProviderDirect from '../lib/modals/content_providers/ContentProviderDirect';

/* global google */

class DirectionsModal extends WindowModal {
  constructor(originText, destinationLatLng, travelMethod) {
    super(
      new ContentProviderDirect(
        '<div class="js-directions-map-panel" style="height: 300px;"></div><div class="js-directions-text-panel" style=""></div>',
        {
          origin_text: originText,
          destination_latlng: destinationLatLng,
          travel_method: travelMethod,
        },
      ),
    );
  }

  initContent(data) {
    const directionsService = new google.maps.DirectionsService();

    const request = {
      origin: data.origin_text,
      destination: data.destination_latlng,
      travelMode: google.maps.DirectionsTravelMode[data.travel_method],
    };

    directionsService.route(request, (response, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        const directionsDisplay = new google.maps.DirectionsRenderer();

        const map = new google.maps.Map(document.querySelector('.js-directions-map-panel'), {
          zoom: 7,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
        });

        directionsDisplay.setMap(map);
        directionsDisplay.setPanel(document.querySelector('.js-directions-text-panel'));
        directionsDisplay.setDirections(response);
      } else {
        this.setContent(
          '<div class="js-directions-map-panel" style="height: 300px;"><p style="text-align:center;">Route not found</p></div>',
        );
      }
    });
  }
}

export default DirectionsModal;



// WEBPACK FOOTER //
// ./src/js/modals/DirectionsModal.js